import { useState } from 'react';
import OzonStock    from './OzonStock';
import StockEntry   from './StockEntry';
import WarehouseMap from './WarehouseMap';

const TABS = [
  { key: 'ozon',  label: 'Ozon Stok',       icon: '📦' },
  { key: 'entry', label: 'Stok Girişi',      icon: '📥' },
  { key: 'whmap', label: 'Depo Eşleştirme', icon: '🏭' },
];

export default function StockHub() {
  const [tab, setTab] = useState('ozon');

  return (
    <div className="min-h-full flex flex-col">
      <div className="px-4 md:px-6 pt-4 md:pt-6 border-b border-gray-200 bg-white sticky top-0 z-10">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Stok Yönetimi</h1>
        <div className="flex gap-1">
          {TABS.map(t => (
            <button key={t.key} onClick={() => setTab(t.key)}
              className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium rounded-t-lg border-b-2 -mb-px transition-colors ${
                tab === t.key
                  ? 'border-blue-600 text-blue-700 bg-blue-50'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}>
              <span>{t.icon}</span> {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1">
        {tab === 'ozon'  && <OzonStock />}
        {tab === 'entry' && <StockEntry />}
        {tab === 'whmap' && <WarehouseMap />}
      </div>
    </div>
  );
}
